(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
